import {BaseApi} from "./baseService";
import {Injectable} from "@angular/core";
import {Http, RequestOptions, URLSearchParams} from "@angular/http";
import {ReportSearchRequest} from "../objects/requests/reportSearchRequest";
import {BaseResponse} from "../objects/common/baseResponse";
import {TotalFeeResponse} from "../objects/report/totalFeeResponse";
/**
 * Created by alex.y on 9/20/2017.
 */
@Injectable()
export class ReportService extends BaseApi {

    public getTotalFee(searchRequest: ReportSearchRequest) : Promise<BaseResponse<Array<TotalFeeResponse>>>{
        return this.post(new RequestOptions({
            url: `report`,
            body: searchRequest
        }));
    }
}


// WEBPACK FOOTER //
// ./app/services/reportService.ts